import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    class: "sf-subnav"
};
const _hoisted_2 = {
    class: "sf-grid"
};
const _hoisted_3 = {
    class: "sf-row sf-row-center"
};
const _hoisted_4 = {
    class: "sf-col sf-xs-12"
};
const _hoisted_5 = {
    class: "sf-subnav-inner sf-level"
};
const _hoisted_6 = [
    "href",
    "aria-current"
];
const _hoisted_7 = {
    class: "sf-font-s tw-pt-2 !tw-pb-2"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'user-management-tabs',
    props: {
        tabs: {}
    },
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab)=>{
                                    return _openBlock(), _createElementBlock("div", {
                                        key: tab.key,
                                        class: "sf-subnav-item sf-level-item"
                                    }, [
                                        _createElementVNode("a", {
                                            href: tab.path,
                                            class: _normalizeClass({
                                                active: tab.active
                                            }),
                                            "aria-current": tab.active ? 'page' : undefined
                                        }, [
                                            _createElementVNode("span", _hoisted_7, _toDisplayString(tab.label), 1)
                                        ], 10, _hoisted_6)
                                    ]);
                                }), 128))
                            ])
                        ])
                    ])
                ])
            ]);
        };
    }
});
